import React from 'react';
import { Toggle } from '@silverfort/sf-components';

interface Props {
    isActive: boolean;
}

const StatusColumn: React.FC<Props> = ({ isActive }) => {
    return (
        <div className="flex items-center justify-center pt-1">
            <Toggle disabled={true} checked={isActive} onChange={() => {}} />
        </div>
    );
};

export default StatusColumn;
